import React from 'react';
import { MdWarning, MdClose } from 'react-icons/md';
import { toast, ToastPosition } from 'react-toastify';
import {
  MainToastWrapper,
  ToastTextWrapper,
  ToastRightWrapper,
  ToastLeftWrapper,
  Title,
  AdditionalInfo,
} from './index.styled';
import { useTheme } from 'styled-components/macro';
import { Button } from 'react-covideo-common';

interface ToastProps {
  title: string;
  additionalInfo?: string;
  button?: {
    text: string;
    textColor: string;
    backgroundColor: string;
    action: () => void;
  };
  position?: ToastPosition | undefined;
}

const CloseToastIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <MdClose size={24} color='rgba(146, 151, 162, 1)' />
  </div>
);

export const ErrorNotification = (props: ToastProps) => {
  const { title, additionalInfo, button } = props;
  const theme = useTheme();
  return (
    <MainToastWrapper>
      <ToastLeftWrapper>
        <MdWarning
          color={theme.colors.danger[100]}
          size={26}
          style={{ minWidth: 26, maxWidth: 26 }}
        />
        <ToastTextWrapper>
          <Title>{title}</Title>
          {additionalInfo && <AdditionalInfo>{additionalInfo}</AdditionalInfo>}
        </ToastTextWrapper>
      </ToastLeftWrapper>
      <ToastRightWrapper>
        {button && (
          <Button
            onClick={button.action}
            variant='primary'
            text={button.text}
            style={{
              backgroundColor: button.backgroundColor,
              color: button.textColor,
            }}
          />
        )}
      </ToastRightWrapper>
    </MainToastWrapper>
  );
};

export const errorToast = (props: ToastProps) =>
  toast(<ErrorNotification {...props} />, {
    progressStyle: { background: 'transparent' },
    position: props.position || 'top-right',
    closeButton: CloseToastIcon,
  });
